import type { OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { closeOverquotaFilesModal, openOverquotaFilesModal } from 'reactApp/ui/OverquotaFilesModal/OverquotaFilesModal';

export function* overquotaFilesOffer({ subscription, continueOutflow, cancelOutflow }: OutflowOfferWebProps) {
    yield openOverquotaFilesModal({
        subscription,
        onCancel() {
            closeOverquotaFilesModal();
            continueOutflow();
        },
        onClose() {
            closeOverquotaFilesModal();
            cancelOutflow();
        },
        onSuccess() {
            closeOverquotaFilesModal();
            cancelOutflow();
        },
    });
}
